import Icon from '@/components/ui/AppIcon';

interface Contact {
  name: string;
  phone: string;
  available: string;
  icon: string;
}

interface EmergencyContactProps {
  contacts: Contact[];
}

const EmergencyContact = ({ contacts }: EmergencyContactProps) => {
  return (
    <div style={{ backgroundColor: 'rgba(239,68,68,0.08)', border: '2px solid rgba(239,68,68,0.3)' }} className="rounded-lg p-8">
      <div className="flex items-center space-x-3 mb-4">
        <div style={{ backgroundColor: '#f87171' }} className="w-12 h-12 rounded-full flex items-center justify-center">
          <Icon name="ExclamationTriangleIcon" size={24} style={{ color: '#0B1622' }} />
        </div>
        <h3 style={{ color: '#f87171' }} className="text-2xl font-headline font-bold">
          Emergency &amp; Medical Support for Divers in Cyprus
        </h3>
      </div>
      
      <p style={{ color: '#C8DDE6' }} className="mb-6 leading-relaxed">
        Cyprus maintains specialised medical facilities for diving-related emergencies. In any suspected diving accident, contact emergency services immediately and follow professional medical advice.
      </p>

      <div className="space-y-4">
        {contacts.map((contact, index) => (
          <div key={index} style={{ backgroundColor: '#0B1622', border: '1px solid rgba(255,255,255,0.06)' }} className="rounded-lg p-4 flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div style={{ backgroundColor: 'rgba(239,68,68,0.1)' }} className="w-10 h-10 rounded-full flex items-center justify-center">
                {contact.icon === 'MedicalIcon' ? (
                  <svg viewBox="0 0 24 24" fill="none" stroke="#f87171" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" aria-label="Medical facility">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                  </svg>
                ) : contact.icon.length <= 2 || !contact.icon.match(/^[A-Z]/) ? (
                  <span className="text-xl" role="img" aria-label="emergency">{contact.icon}</span>
                ) : (
                  <Icon name={contact.icon as any} size={20} style={{ color: '#f87171' }} />
                )}
              </div>
            </div>
            <div className="flex-1">
              <h4 style={{ color: '#EAF4F8' }} className="font-semibold mb-1">{contact.name}</h4>
              <p style={{ color: '#f87171' }} className="text-sm font-medium mb-1">{contact.phone}</p>
              <p style={{ color: '#C8DDE6' }} className="text-xs">{contact.available}</p>
              {contact.name.includes('Hospital') && (
                <a
                  href={`https://www.google.com/maps/search/${encodeURIComponent(contact.name + ' Cyprus')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#6FD3E0' }}
                  className="inline-flex items-center space-x-1 text-xs hover:opacity-80 mt-2 transition-opacity"
                >
                  <Icon name="MapPinIcon" size={14} />
                  <span>View on map</span>
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      <div style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(111,211,224,0.12)' }} className="mt-6 rounded-lg p-4 flex items-start space-x-3">
        <Icon name="InformationCircleIcon" size={20} style={{ color: '#6FD3E0' }} className="flex-shrink-0 mt-0.5" />
        <p style={{ color: '#C8DDE6' }} className="text-xs">
          Emergency information is provided for general guidance only. Always follow instructions from local authorities and medical professionals.
        </p>
      </div>
    </div>
  );
};

export default EmergencyContact;